// extracted by mini-css-extract-plugin
export default {"FullWidthButton":"sPfjEtWg5boub5Jf9NTs"};